export default {
  "nav.events": "Үйл явдал",
  "nav.gallery": "Галерей",
  "nav.contact": "Холбоо барих",

  "hero.benefit": "3 Өрөө • 10 DJ • 1 Бүрэн эрхт тасалбар",
  "hero.getTickets": "Тасалбар авах",
  "hero.soldOut": "Дууссан",

  "land.saveDate": "Огноог тэмдэглэ",
  "land.upcomingA": "Удахгүй болох",
  "land.upcomingB": "үйл явдал",
  "land.festival": "Фестиваль",
  "land.getTicketsArrow": "Тасалбар авах →",

  "home.watchEyebrow": "Афтермуви & тойм",
  "home.watchA": "Takeover-ыг",
  "home.watchB": "үзеэрэй",
  "home.stagesEyebrow": "Нэг тасалбар, гурван ертөнц",
  "home.stagesA": "Танилц",
  "home.stagesB": "3 Тайз",
  "stage.seoul.name": "Seoul Floor",
  "stage.seoul.desc": "SeoulVibes хамт",
  "stage.seoul.floor": "7 давхар",
  "stage.main.name": "Mainstream Floor",
  "stage.main.desc": "Сонгодог DUPLEX туршлага",
  "stage.main.floor": "6 давхар",
  "stage.saigon.name": "Saigon Floor",
  "stage.saigon.desc": "GANGSHII хамт",
  "stage.saigon.floor": "5 давхар",
  "home.lineupEyebrow": "Уран бүтээлчид",
  "home.whoA": "Хэн тоглох вэ",
  "home.whoB": "— хэзээ?",
  "home.insideEyebrow": "Дээрээс нь",
  "home.insideA": "Duplex",
  "home.insideB": "дотор",
  "home.ctaA": "Takeover-д",
  "home.ctaB": "бэлэн үү?",
  "home.buyTickets": "Тасалбар авах",

  "footer.tagline": "Прагийн хамгийн том ази фестивалийн туршлага. Гурван өрөө, нэг тасалбар, мартагдашгүй шөнө.",
  "footer.quickLinks": "Хурдан холбоос",
  "footer.faq": "Түгээмэл асуулт",
  "footer.terms": "Үйлчилгээний нөхцөл",
  "footer.privacy": "Нууцлалын бодлого",
  "footer.refund": "Буцаан олголтын бодлого",
  "footer.followUs": "Биднийг дага",
  "footer.rights": "© 2026 ASIA TAKEOVER. Бүх эрх хуулиар хамгаалагдсан.",
  "footer.doorStaff": "Хаалганы ажилтан",
  "footer.admin": "Admin",

  "cookies.title": "Cookies",
  "cookies.text": "Бид сайтыг ажиллуулах, захиалга боловсруулахын тулд зайлшгүй cookies ашигладаг. Таны зөвшөөрлөөр мөн шинжилгээ болон маркетингийн cookies (Meta Pixel) ашиглаж зар сурталчилгааны үр дүнг хэмждэг. Та нэмэлт cookies-г татгалзаж ч тасалбар авах боломжтой.",
  "cookies.necessary": "Зайлшгүй (үргэлж идэвхтэй)",
  "cookies.analytics": "Шинжилгээ",
  "cookies.marketing": "Маркетинг / Meta Pixel",
  "cookies.acceptAll": "Бүгдийг зөвшөөрөх",
  "cookies.customize": "Тохируулах",
  "cookies.save": "Хадгалах",
  "cookies.reject": "Татгалзах",

  "tickets.eyebrow": "Тасалбар",
  "tickets.standard": "Standard тасалбар",
  "tickets.group": "4 хүний багц",
  "tickets.vip": "VIP ширээний тасалбар",
  "tickets.nextRelease": "Дараагийн борлуулалт:",
  "tickets.finalRelease": "Онлайн тасалбарын сүүлийн борлуулалт",
  "tickets.soldOut": "Дууссан",
  "tickets.buy": "Тасалбар авах",
  "tickets.buyGroup": "Багц тасалбар авах",
  "tickets.groupPerPerson": "4 × Standard тасалбар · нэг хүн {price}",
  "tickets.limitedCapacity": "Тоо хязгаартай",
  "tickets.reserve": "Ширээ захиалах",
  "tickets.vipRequired": "VIP ширээний тасалбар шаардлагатай",
  "tickets.wantTable": "Bottle service-тэй ширээ захиалах уу? VIP ширээний тасалбар шаардлагатай.",
  "tickets.noRefund": "Тасалбар буцаагддаггүй · зөвхөн зохион байгуулагч үйл явдлыг цуцалбал 100% буцаана",
  "tickets.swipe": "Дэлгээр үзэх",
  "tickets.priceProgression": "Үнэ борлуулалт бүр дуусах тусам нэмэгдэнэ",
  "tickets.loading": "Тасалбар ачаалж байна…",
  "tickets.unavailable": "Тасалбар одоогоор ачаалагдахгүй байна",
  "perks.std1": "3 тайзанд бүгдэд нь нэвтрэх",
  "perks.std2": "Зогсох болон бүжгийн талбай",
  "perks.std3": "Бүх нийтийн бар болон rooftop руу нэвтрэх",
  "perks.no1": "VIP ширээний бүс рүү нэвтрэхгүй",
  "perks.no2": "Захиалсан ширээ, баталгаат суудалгүй",
  "perks.no3": "Bottle service байхгүй",
  "perks.vip1": "Гэнэтийн бэлэг ❤️‍🔥🎈 (200 Kč үнэтэй)",
  "perks.vip2": "Seoul Floor (7 давхар) болон Saigon Floor (5 давхар)-ын VIP бүс рүү нэвтрэх.",
  "tickets.gold": "VIP Gold Table",
  "tickets.goldBadge": "Ердөө 3 ширээ",
  "tickets.goldFee": "Ширээний төлбөр 3999 Kč + зочин бүр 899 Kč",
  "perks.gold1": "Тайзны ойролцоо ширээ",
  "perks.gold2": "3 тайзанд бүгд нэвтрэх",
  "perks.gold3": "Seoul Floor (7 давхар) болон Saigon Floor (5 давхар)-ын VIP бүс рүү нэвтрэх",
  "perks.gold4": "Тэргүүлэх эрэмбээр орох, VIP ариун цэврийн өрөө, hostess үйлчилгээ",
  "perks.gold5": "Зочин бүрт 1 гэнэтийн бэлэг",
  "perks.gold6": "Bottle service тусад нь",
  "tickets.buyGold": "Gold Table авах",
  "checkout.guestsGold": "Зочид (4–14)",
  "checkout.guestsWord": "зочин",
  "hero.upgrade": "VIP болгон шилжүүлэх",
  "upgrade.title": "VIP болгон шилжүүлэх",
  "upgrade.subtitle": "Стандарт тасалбартай юу? 400 Kč-өөр VIP Table болгон шилжүүл.",
  "upgrade.codeLabel": "Тасалбарын код",
  "upgrade.codePlaceholder": "ATF-XXXXXX",
  "upgrade.verify": "Тасалбар шалгах",
  "upgrade.found": "Тасалбар олдлоо",
  "upgrade.priceLine": "Шилжүүлгийн үнэ",
  "upgrade.sameQr": "QR код чинь хэвээр — төлбөрийн дараа VIP болж сканердэна.",
  "upgrade.pay": "Шилжүүлэг төлөх",
  "upgrade.processing": "Төлбөр үүсгэж байна…",
  "success.upgradeNote": "Тасалбар чинь VIP боллоо — хуучин QR кодоо ашиглаарай.",
  "perks.vip3": "Bottle service-тэй VIP ширээ захиалах боломж",
  "perks.vip4": "Захиалсан ширээнд hostess үйлчилгээ",
  "perks.vip5": "7 давхрын VIP балкон руу нэвтрэх",
  "perks.vip6": "Тэргүүлэх эрэмбээр орох",
  "perks.vip7": "VIP ариун цэврийн өрөө",

  "checkout.secure": "Аюулгүй төлбөр",
  "checkout.fullName": "Бүтэн нэр",
  "checkout.namePlaceholder": "Таны нэр",
  "checkout.email": "Имэйл",
  "checkout.phone": "Утасны дугаар",
  "checkout.quantity": "Тоо ширхэг",
  "checkout.ticketOne": "тасалбар",
  "checkout.ticketMany": "тасалбар",
  "checkout.groupNote": "1 багц = 4 тасалбар",
  "checkout.discountCode": "Хөнгөлөлтийн код",
  "checkout.enterCode": "Код оруулах",
  "checkout.apply": "Хэрэглэх",
  "checkout.codeApplied": "{code} код хэрэгжлээ: −{percent}% (анхны үнэ {price})",
  "checkout.continueToPayment": "Төлбөр рүү үргэлжлүүлэх",
  "checkout.secureNote": "Teya-гийн аюулгүй картаар төлөх үйлчилгээ, шууд энэ хуудсан дээр. Тасалбар зөвхөн төлбөр баталгаажсаны дараа гардаг.",
  "checkout.termsNoteA": "Үргэлжлүүлснээр та манай",
  "checkout.termsNoteB": "Үйлчилгээний нөхцөл",
  "checkout.termsNoteC": "-ийг зөвшөөрч байна. Тасалбар буцаагддаггүй, чөлөөтэй шилжүүлэх боломжтой.",
  "checkout.creating": "Захиалга үүсгэж байна…",
  "checkout.securePayment": "Аюулгүй төлбөр",
  "checkout.groupTickets": "1 багц (4 тасалбар)",
  "checkout.teyaNote": "Төлбөрийг Teya боловсруулдаг. QR кодтой тасалбар төлбөр баталгаажмагц имэйлээр ирнэ.",
  "checkout.promoApplyFirst": "Төлөхөөс өмнө хөнгөлөлтийн кодоо идэвхжүүлэхийн тулд Хэрэглэх товчийг дарна уу.",

  "success.confirming": "Төлбөр баталгаажуулж байна…",
  "success.confirmingText": "Бид таны төлбөрийг төлбөрийн гарцтай шалгаж байна. Энэ хуудас автоматаар шинэчлэгдэнэ — дахин ачаалах шаардлагагүй.",
  "success.slowNote": "Хэвийнээсээ бага зэрэг удаж байна — төлбөр тань баталгаажиж байгаа. Дуусмагц тасалбар энд гарч ирэх бөгөөд имэйлээр ч явуулна. Энэ хуудсыг нээлттэй орхиж болно.",
  "success.confirmed": "Төлбөр баталгаажлаа",
  "success.youreIn": "Та дотогшлоо!",
  "success.orderLine": "Захиалга {order} · {tier} × {qty} · {amount} · Тасалбараа screenshot хийж, хаалганы дээр QR кодыг үзүүлнэ үү.",
  "success.loadingTickets": "Тасалбар ачаалж байна…",
  "success.notCompleted": "Төлбөр дуусаагүй",
  "success.cancelled": "Төлбөр цуцлагдсан.",
  "success.expired": "Төлбөрийн хугацаа дууссан.",
  "success.failed": "Төлбөр амжилтгүй болсон.",
  "success.noCharge": "Тасалбар гараагүй бөгөөд танаас мөнгө авагдаагүй.",
  "success.backToTickets": "Тасалбар руу буцах",
  "success.refunded": "Захиалга буцаагдсан",
  "success.refundedText": "Энэ захиалга {how} буцаагдсан.",
  "success.fully": "бүрэн",
  "success.partially": "хэсэгчлэн",
  "success.notFound": "Захиалга олдсонгүй",
  "success.notFoundText": "Энэ захиалгыг олж чадсангүй. Төлбөрөө сая хийсэн бол хэсэг хүлээгээд дахин шалгана уу.",
  "success.backHome": "← Нүүр рүү буцах",

  "reserve.eyebrow": "VIP ширээний тасалбар",
  "reserve.titleA": "Ширээ",
  "reserve.titleB": "захиалах",
  "reserve.intro": "Юу хэрэгтэйгээ хэлээрэй — бид ширээний сонголт болон bottle service-ийн дэлгэрэнгүйг илгээнэ.",
  "reserve.received": "Хүсэлт хүлээн авлаа",
  "reserve.receivedText": "Бид удахгүй тантай холбогдож VIP ширээгээ тохируулна. 27.09-нд DUPLEX-д уулзаарай.",
  "reserve.back": "← Тасалбар руу буцах",
  "reserve.fullName": "Бүтэн нэр",
  "reserve.phone": "Утасны дугаар",
  "reserve.email": "Имэйл",
  "reserve.guests": "Зочдын тоо",
  "reserve.floor": "Сонгох давхар",
  "reserve.message": "Захиа (заавал биш)",
  "reserve.messagePlaceholder": "Үйл явдал, төсөв, ундааны сонголт…",
  "reserve.send": "Хүсэлт илгээх",
  "reserve.sending": "Илгээж байна…",

  "contact.eyebrow": "Холбоо барих",
  "contact.title": "Холбогдоорой",
  "contact.email": "Имэйл",
  "contact.instagram": "Instagram",
  "contact.venue": "Байршил",
  "contact.note": "VIP ширээ, хамтын ажиллагаа, хэвлэл мэдээний асуудлаар имэйл бичнэ үү — 48 цагийн дотор хариулна.",

  "gallery.eyebrow": "Галерей",
  "gallery.titleA": "Газрын",
  "gallery.titleB": "зураг",
  "gallery.rooms": "KPOP өрөө • Mainstream өрөө • Saigon өрөө",
};
